import { __assign, __read } from "tslib";
import React, { useState, useRef, useEffect } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Bubble } from "../bubble";
import { useTranslation } from "../i18n";
import { Icon } from "../icon";
import { injectValue } from "../_util/inject-value";
import { noop } from "../_util/noop";
function HoverTrigger(_a) {
    var setVisible = _a.setVisible, _b = _a.openDelay, openDelay = _b === void 0 ? 50 : _b, _c = _a.closeDelay, closeDelay = _c === void 0 ? 100 : _c, render = _a.render, onReset = _a.onReset;
    var commonProps = {
        onMouseEnter: function () {
            onReset();
            setVisible(true, openDelay);
        },
        onMouseLeave: function () { return setVisible(false, closeDelay); },
    };
    return render({
        overlayProps: commonProps,
        childrenProps: commonProps,
    });
}
HoverTrigger.displayName = "CopyHoverTrigger";
export function Copy(props) {
    var t = useTranslation();
    var text = props.text, _a = props.tips, tips = _a === void 0 ? function (copied) { return (copied ? t.copied : t.copy); } : _a, _b = props.onCopy, onCopy = _b === void 0 ? noop : _b, _c = props.children, children = _c === void 0 ? React.createElement(Icon, { type: "copy" }) : _c;
    var _d = __read(useState(false), 2), copied = _d[0], setCopied = _d[1];
    var timerRef = useRef(null);
    useEffect(function () { return function () { return clearTimeout(timerRef.current); }; }, []);
    var element = injectValue(children)(copied);
    return (React.createElement(Bubble, { trigger: [
            HoverTrigger,
            {
                onReset: function () {
                    setCopied(false);
                    clearTimeout(timerRef.current);
                },
            },
        ], content: injectValue(tips)(copied) },
        React.createElement(CopyToClipboard, { text: text, onCopy: function (text, result) {
                onCopy(text, { result: result });
                if (result) {
                    if (timerRef.current) {
                        clearTimeout(timerRef.current);
                    }
                    setCopied(true);
                    timerRef.current = setTimeout(function () { return setCopied(false); }, 1500);
                }
            } }, React.isValidElement(element) ? (React.cloneElement(element, {
            style: __assign({ cursor: "pointer" }, (element.props.style || {})),
        })) : (React.createElement("span", { style: { cursor: "pointer" } }, element)))));
}
Copy.displayName = "Copy";
//# sourceMappingURL=Copy.js.map